import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPONSE_ADD_ICE_SERVER,
    RESPONSE_REMOVE_ICE_SERVER,
    RESPONSE_LIST_ICE_SERVERS,
    RESPONSE_UPDATE_ICE_SERVER,
    RESPONSE_DEFAULT_ICE_SERVER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/spaces/iceMsgDefinitions";
import {
    SpacesIceServer,
    SpacesIceServerID,
    SpacesIceServerDefault,
} from "userful-chronos-app-common-js/dist/models/spaces/ice";
import spacesStore from "../../spacesStore";
import { iceActions } from "../../iceSlice";
import { requestDefaultIceServer } from "./iceMsgSender";

registerMsgHandler(RESPONSE_LIST_ICE_SERVERS, (payload) => {
    console.log("receive RESPOND_LIST_SERVERS", payload);
    const data = JSON.parse(payload) as SpacesIceServer[];
    spacesStore.dispatch(iceActions.setIceServers(data));
    // Request default server after we have the list
    requestDefaultIceServer();
});

registerMsgHandler(RESPONSE_ADD_ICE_SERVER, (payload) => {
    console.log("receive RESPOND_ADD_SERVER", payload);
    const data = JSON.parse(payload) as SpacesIceServer;
    spacesStore.dispatch(iceActions.changeLoadState("RENDER"));
    spacesStore.dispatch(iceActions.setOpenForm(false));
    spacesStore.dispatch(iceActions.addOrUpdateIceServer(data));
});

registerMsgHandler(RESPONSE_UPDATE_ICE_SERVER, (payload) => {
    console.log("receive RESPONSE_UPDATE_ICE_SERVER", payload);
    const data = JSON.parse(payload) as SpacesIceServer;
    spacesStore.dispatch(iceActions.changeLoadState("RENDER"));
    spacesStore.dispatch(iceActions.setOpenForm(false));
    spacesStore.dispatch(iceActions.addOrUpdateIceServer(data));
    spacesStore.dispatch(iceActions.setIceServer(SpacesIceServerDefault())); // Reset form state
    spacesStore.dispatch(iceActions.setCopyIceServer(SpacesIceServerDefault())); // Reset copy state
});

registerMsgHandler(RESPONSE_REMOVE_ICE_SERVER, (payload) => {
    console.log("receive RESPONSE_REMOVE_ICE_SERVER", payload);
    const data = JSON.parse(payload) as SpacesIceServerID;
    spacesStore.dispatch(iceActions.removeIceServer(data));
});

registerMsgHandler(RESPONSE_DEFAULT_ICE_SERVER, (payload) => {
    console.log("receive RESPONSE_DEFAULT_ICE_SERVER", payload);
    const parsedData = JSON.parse(payload) as SpacesIceServer;
    const data = { ...parsedData, isDefault: true };
    const iceServers = spacesStore.getState().iceStore.iceServers;

    // First ensure unique IDs
    const uniqueIds = new Set();
    let updatedServers = iceServers.filter((server) => {
        const serverId = server?.id?.value;
        if (!serverId || uniqueIds.has(serverId)) {
            return false;
        }
        uniqueIds.add(serverId);
        return true;
    });

    // Set all servers to isDefault: false
    updatedServers = updatedServers.map((server) => ({
        ...server,
        isDefault: false,
    }));

    // Add or update the default server
    const existingServerIndex = updatedServers.findIndex((server) => server.id.value === data.id.value);
    if (existingServerIndex !== -1) {
        updatedServers[existingServerIndex] = data;
    } else {
        updatedServers.push(data);
    }

    spacesStore.dispatch(iceActions.setIceServers(updatedServers));
});
